import React from 'react'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { ISolutionCard as IContentfulSolutionCard } from 'marketing-site/@types/generated/contentful'
import { IProps as ISolutionCard } from 'marketing-site/src/library/elements/SolutionCard'
import {
  isCTALink,
  transformCTALink,
} from 'marketing-site/src/transformers/elements/ContentfulCTALink'
import {
  ICtaLink as IContentfulCtaLink,
  IModalButton as IContentfulModalButton,
} from 'marketing-site/@types/generated/contentful'
import { transformAssetToImage } from './ContentfulImage'
import { isModalButton, transformModalButton } from './ContentfulModalButton'
import * as Utils from 'marketing-site/src/library/utils'
import { SolutionCard } from 'marketing-site/src/library/elements/SolutionCard/element'

export const ContentfulSolutionCard = (props: IContentfulSolutionCard): React.ReactElement => (
  <EntryMarker entry={props}>
    {() => <SolutionCard {...transformSolutionCard(props)} />}
  </EntryMarker>
)

export function transformSolutionCard({ sys, fields }: IContentfulSolutionCard): ISolutionCard {
  return {
    ...fields,
    contentType: sys.contentType.sys.id,
    title: fields.title,
    body: fields.bodyText?.trim(),
    staticImage: transformAssetToImage(fields.image),
    animatedImage: fields.animatedImage && transformAssetToImage(fields.animatedImage),
    cta: transformCTA(fields.cta),
    cardColor: Utils.getHexColorFromName(fields.cardColor),
    borderColor: fields.borderColor ? Utils.getHexColorFromName(fields.borderColor) : undefined,
    icon: fields.icon && fields.icon.fields.file.url,
  }
}

const transformCTA = (cta?: IContentfulCtaLink | IContentfulModalButton) => {
  if (!cta) return undefined
  if (isCTALink(cta)) return transformCTALink(cta)
  if (isModalButton(cta)) return transformModalButton(cta)
}
